import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Brand } from "../../components/Brand";
import { useSEO } from "../../lib/seo";
import api from "../../lib/api";
import { useState } from "react";
import { toast } from "sonner";

const NAV = [
    { to: "/technician", label: "Jobs", icon: "📋", end: true, testid: "tech-nav-jobs" },
    { to: "/technician/earnings", label: "Earnings", icon: "💰", testid: "tech-nav-earn" },
    { to: "/technician/profile", label: "Profile", icon: "👤", testid: "tech-nav-profile" },
];

export default function TechnicianLayout() {
    useSEO({ title: "Technician Console — LETS Pro", noindex: true });
    const { user, logout, refreshMe } = useAuth();
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    const toggleAvailable = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/me/availability", {
                available: !user.available,
            });
            toast.success(data.available ? "You're online" : "You're offline");
            await refreshMe();
        } catch (e) {
            toast.error("Failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F3F2F0] max-w-md mx-auto md:max-w-2xl shadow-2xl">
            <header className="sticky top-0 z-30 bg-[#180A21] text-white">
                <div className="px-5 py-4 flex items-center justify-between">
                    <Link to="/technician">
                        <Brand light size="small" />
                    </Link>
                    <button
                        data-testid="tech-logout-btn"
                        onClick={async () => {
                            await logout();
                            nav("/login");
                        }}
                        className="text-xs text-white/60 hover:text-white"
                    >
                        Sign out
                    </button>
                </div>
                <div className="px-5 pb-5 flex items-center justify-between gap-4">
                    <div className="min-w-0 flex-1">
                        <div className="lx-label text-[#D4AF37]">Welcome</div>
                        <div className="font-sans font-bold text-2xl tracking-tight truncate">
                            {user?.name}
                        </div>
                        <div className="text-xs text-white/60 mt-0.5">
                            ★ {user?.rating_avg?.toFixed(1)} · {user?.completed_jobs} jobs
                        </div>
                    </div>
                    <button
                        data-testid="tech-availability-toggle"
                        onClick={toggleAvailable}
                        disabled={busy}
                        className={`shrink-0 px-4 py-2.5 text-xs font-semibold tracking-wider uppercase border transition ${
                            user?.available
                                ? "bg-[#34C759] text-white border-[#34C759]"
                                : "bg-transparent text-white/70 border-white/30"
                        }`}
                    >
                        ● {user?.available ? "Online" : "Offline"}
                    </button>
                </div>
            </header>

            <main className="px-5 py-6 pb-24">
                <Outlet />
            </main>

            <nav className="fixed bottom-0 left-0 right-0 max-w-md mx-auto md:max-w-2xl bg-white border-t border-[#E5E2DC] flex z-30 shadow-2xl">
                {NAV.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        end={item.end}
                        data-testid={item.testid}
                        className={({ isActive }) =>
                            `flex-1 py-3.5 text-center text-xs font-medium transition ${
                                isActive ? "text-[#180A21]" : "text-[#555]"
                            }`
                        }
                    >
                        {({ isActive }) => (
                            <>
                                <div className="text-lg">{item.icon}</div>
                                <div
                                    className={`mt-0.5 ${isActive ? "border-t-2 border-[#D4AF37] pt-0.5" : ""}`}
                                >
                                    {item.label}
                                </div>
                            </>
                        )}
                    </NavLink>
                ))}
            </nav>
        </div>
    );
}
